// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Do not edit directly
 * Generated on Wed, 20 Mar 2024 11:09:37 GMT
 */

body[data-theme="dui-dhl"] {
  --dui-brand-color-headline: #d40511;
  --dui-brand-color-icon: currentColor;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@dhl-official/tokens/dist/css/semantics/dhl.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,mCAAmC;EACnC,oCAAoC;AACtC","sourcesContent":["/**\n * Do not edit directly\n * Generated on Wed, 20 Mar 2024 11:09:37 GMT\n */\n\nbody[data-theme=\"dui-dhl\"] {\n  --dui-brand-color-headline: #d40511;\n  --dui-brand-color-icon: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
